import PropTypes from "prop-types";
import React from "react";

export const Cancel = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M 14 0  C 6.170452919584136 0  0 6.170452919584079  0 14  C 0 21.829547080415864  6.170452919584136 28  14 28  C 21.829547080415864 28  28 21.829547080415864  28 14  C 28 6.170452919584079  21.829547080415864 0  14 0  Z M 14 2.7096774193548185  C 20.333033564745392 2.7096774193548185  25.290322580645125 7.666966435254609  25.290322580645125 14  C 25.290322580645125 20.333033564745392  20.333033564745392 25.290322580645125  14 25.290322580645125  C 7.666966435254609 25.290322580645125  2.7096774193548754 20.333033564745392  2.7096774193548754 14  C 2.7096774193548754 7.666966435254609  7.666966435254609 2.7096774193548185  14 2.7096774193548185  Z M 15.819699219665495 14.000000000000115  C 15.819699219665495 14.000000000000115  20.62571618807317 9.191717016284088  20.62571618807317 9.191717016284088  C 21.12516315040648 8.692034566962377  21.126194675268835 7.882921257678333  20.620195300904015 7.376683306892403  C 20.11769923678196 6.873950318144182  19.300173319603687 6.876770472964893  18.806016968407675 7.371159816650106  C 18.806016968407675 7.371159816650106  14 12.179442800366019  14 12.179442800366019  C 14 12.179442800366019  9.19398303159221 7.371159816650333  9.19398303159221 7.371159816650333  C 8.6998266803962 6.876770472965177  7.882300763217926 6.873950318144409  7.379804699095871 7.376683306892687  C 6.873805324731052 7.882921257678618  6.874836849593635 8.692034566962604  7.37428381192683 9.191717016284315  C 7.37428381192683 9.191717016284315  12.180300780334619 14.000000000000115  12.180300780334619 14.000000000000115  C 12.180300780334619 14.000000000000115  7.374283811926943 18.808282983715685  7.374283811926943 18.808282983715685  C 6.874836849593635 19.307965433037452  6.873805324731052 20.117078742321496  7.379804699095871 20.623316693107427  C 7.882300763217926 21.126049681855648  8.6998266803962 21.123229527035278  9.19398303159221 20.62884018335012  C 9.19398303159221 20.62884018335012  14 15.820557199634209  14 15.820557199634209  C 14 15.820557199634209  18.806016968407675 20.62884018335012  18.806016968407675 20.62884018335012  C 19.300173319603687 21.123229527035278  20.11769923678196 21.126049681855648  20.620195300904015 20.623316693107427  C 21.126194675268835 20.117078742321496  21.125163150406365 19.307965433037452  20.62571618807317 18.808282983715685  C 20.62571618807317 18.808282983715685  15.819699219665495 14.000000000000115  15.819699219665495 14.000000000000115  Z " />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 0 28 28",
    };
  }
};

Cancel.displayName = "CancelIcon";

Cancel.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Cancel.defaultProps = { role: "img" };
